import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ChangeEvent, type KeyboardEvent, type RefObject } from "react";

import { getShortcutHint } from "./KeyboardHints";

interface OmnisearchInputProps {
  value: string;
  inputRef: RefObject<HTMLInputElement>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
}

export function OmnisearchInput(props: OmnisearchInputProps) {
  const { value, inputRef, onChange, onKeyDown } = props;

  return (
    <TextField
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      fullWidth
      inputRef={inputRef}
      placeholder="Search professionals, workplaces..."
      value={value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <Text
              sx={{
                color: "text.secondary",
                backgroundColor: "action.hover",
                px: 1,
                py: 0.5,
                borderRadius: 1,
                fontFamily: "monospace",
              }}
              variant="caption"
            >
              {getShortcutHint()}
            </Text>
          </InputAdornment>
        ),
        sx: { py: 1.5, px: 2, "& fieldset": { border: "none" } },
      }}
      onChange={onChange}
      onKeyDown={onKeyDown}
    />
  );
}
